import { inject, Injectable } from "@angular/core";
import { EffectsBase } from "clicklease-ui-elements";
import { getContractSelectedIdSelector } from "../contracts/contracts.selectors";
import { LeaseService } from "../../services";
import { postDownloadStatementData, postDownloadStatementDataError, postDownloadStatementDataSuccess } from "./download-statement-form.actions";
import { ofType } from "@ngrx/effects";
import { catchError, first, map, mergeMap, of } from "rxjs";

@Injectable()
export class DownloadStatementFormEffect extends EffectsBase {

    readonly #contractSelected = this.store.selectSignal(getContractSelectedIdSelector);
    readonly #leaseService: LeaseService = inject(LeaseService);

    postDownloadStatementDataEffect = this.createEffect(() =>
        this.actions.pipe(
            ofType(postDownloadStatementData),
            mergeMap(({ statementDates }) => {
                return this.#leaseService.postDownloadLeaseStatement(this.#contractSelected(), statementDates).pipe(
                    map((statementDocument) => postDownloadStatementDataSuccess({ statementDocument })),
                    catchError((error) => of(postDownloadStatementDataError({ error: error.error }))),
                    first()
                )
            }))
    );
}